import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-brand-blue px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="DEFAR" className="h-16 mx-auto bg-white p-2 rounded-sm" />
          <h1 className="mt-6 text-2xl font-bold text-white">Espace administrateur</h1>
          <p className="mt-2 text-blue-200 text-sm">Connectez-vous pour gérer la plateforme</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-sm p-7 space-y-5">
          {error && (
            <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-sm">
              {error}
            </div>
          )}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full border border-border px-4 py-2.5 rounded-sm text-sm focus:outline-none focus:border-brand-blue" placeholder="admin@defar.sn" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full border border-border px-4 py-2.5 rounded-sm text-sm focus:outline-none focus:border-brand-blue" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full flex items-center justify-center gap-2 bg-brand-green text-white hover:bg-brand-greenhover transition-colors py-3 font-semibold disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />}
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
        <p className="text-center text-blue-200 text-xs mt-6">
          <a href="/" className="hover:text-white">← Retour au site public</a>
        </p>
      </div>
    </div>
  );
}
